import React from 'react';
import PropTypes from 'prop-types';
import { Meteor } from 'meteor/meteor';
import { withTracker } from 'meteor/react-meteor-data';
import Loading from '../../components/Loading';
import MapServerElementEditor from '../../components/MapServerElementEditor';
import PageHeader from '../../atoms/PageHeader';

const NewMapServerElement = ({ history, loading }) => {
  if (loading) {
    return <Loading />;
  }
  return (
    <>
      <PageHeader>
        <h4>New Layer Server</h4>
      </PageHeader>
      <MapServerElementEditor history={history} />
    </>
  );
};

NewMapServerElement.propTypes = {
  history: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired
};

export default withTracker(() => {
  const mapServerElementSub = Meteor.subscribe('mapServerElements');

  return {
    loading: !mapServerElementSub.ready()
  };
})(NewMapServerElement);
